export type NotificationProcessingStatusKey = 'pendiente_procesar' | 'procesada';

export interface NotificationCategoryCount {
  categoryKey: string;
  categoryLabel: string;
  total: number;
}

export interface NotificationSummary {
  total: number;
  unread: number;
  categories: NotificationCategoryCount[];
}

export interface NotificationItem {
  notificationUuid: string;
  categoryKey: string;
  categoryLabel: string;
  stepKey: string;
  stepLabel: string;
  actorName: string | null;
  actorArea: string | null;
  creatorName: string | null;
  creatorArea: string | null;
  processedByName: string | null;
  processedByArea: string | null;
  prospectName?: string | null;
  prospectPhone?: string | null;
  project: string | null;
  realEstateAgency?: string | null;
  unit: string | null;
  model: string | null;
  createdAt: string;
  processingStatus: NotificationProcessingStatusKey;
  processingStatusLabel: string;
  detailStatusKey: string | null;
  detailStatusLabel: string | null;
  detailText: string | null;
  cancellationReason?: string | null;
  requestComment?: string | null;
  rejectionComment: string | null;
  resolutionComment?: string | null;
  viewed: boolean;
  saleUuid: string | null;
  stageProspectUuid: string | null;
  recordType: string | null;
  sourceUuid: string | null;
  sourceType: string | null;
}

export interface NotificationRealtimeEvent {
  eventType: string;
  notificationUuid: string;
  occurredAt: string;
  unreadCount?: number | null;
}

export interface NotificationListQuery {
  page?: number;
  size?: number;
  processingStatus?: NotificationProcessingStatusKey | null;
  categoryKey?: string | null;
  viewed?: boolean | null;
}

export interface NotificationSummaryQuery {
  processingStatus?: NotificationProcessingStatusKey | null;
  viewed?: boolean | null;
}

export interface NotificationCategoryDefinition {
  key: string;
  label: string;
}

export const NOTIFICATION_PROCESSING_LABELS: Record<NotificationProcessingStatusKey, string> = {
  pendiente_procesar: 'Pendiente de procesar',
  procesada: 'Procesada'
};

export const KNOWN_NOTIFICATION_CATEGORIES: NotificationCategoryDefinition[] = [
  {
    key: 'revision_expediente',
    label: 'Revisión de expediente'
  },
  {
    key: 'cancelacion_venta',
    label: 'Cancelación de venta'
  },
  {
    key: 'monitoreo_prospectos',
    label: 'Monitoreo de prospectos'
  }
];

export const EMPTY_NOTIFICATION_SUMMARY: NotificationSummary = {
  total: 0,
  unread: 0,
  categories: []
};
